document.querySelectorAll('.school_activities_faq-content-list li > *:first-child').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.target.parentElement.classList.toggle('extended')
  }, { passive: true })
})
